import Vue from 'vue'
import Router from 'vue-router'
import Cookies from 'js-cookie'
import RouterTable from '@/router/router'
import store from '@/store'
import { InitWxConfig, IsWechat } from '@/assets/scripts/wechat'
import { BASE_URL } from '@/assets/scripts/api'
import { Loading } from '@/assets/scripts/helper'

Vue.use(Router)

let $router = new Router({
  base: BASE_URL,
  mode: 'history',
  routes: RouterTable,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition && store.state.keepAlive.indexOf(to.name) !== -1) {
      return savedPosition
    } else {
      return {x: 0, y: 0}
    }
  }
})

$router.beforeEach((to, from, next) => {
  Loading.close()
  if (window.__axiosPromiseArr.length > 0) {
    window.__axiosPromiseArr.forEach((ele, index) => {
      let arr = ['/wx/2/system/center.json', '/wx/1/appointment/configInfo.json', '/wx/user/getUser.json', '/wx/logout.json']
      arr.includes(ele.code) || ele.cancel()
      delete window.__axiosPromiseArr[index]
    })
  }
  if (to.meta.title) {
    document.title = to.meta.title
  } else {
    document.title = '体检专家'
  }
  if (to.query.token) {
    Cookies.set('51jk.CID', to.query.clientId)
    Cookies.set('51jk.TK', to.query.token)
    store.dispatch('user/getUserData')
  }
  // 利用路由守卫记录地址栏?sid=xxx的入口参数
  if (from.name == null && to.query.sid) {
    Cookies.set('51jk._sid', to.query.sid || '00-0')
    Cookies.set('51jk._initSid', to.query.initializeSid || to.query.sid || '00-0')
  } else if (from.name && from.query.sid) {
    Cookies.set('51jk._sid', from.query.sid)
    if (to.name === 'main') {
      to.query.sid = Cookies.get('51jk._initSid') || from.query.sid
    } else {
      to.query.sid = from.query.sid || Cookies.get('51jk._initSid')
    }
  } else if (Cookies.get('51jk._sid') || Cookies.get('51jk._initSid')) {
    if (to.name === 'main') {
      to.query.sid = Cookies.get('51jk._initSid') || Cookies.get('51jk._sid')
    } else {
      to.query.sid = Cookies.get('51jk._sid') || Cookies.get('51jk._initSid')
    }
  } else {
    to.query.sid = '00-0'
    Cookies.set('51jk._sid', '00-0')
    Cookies.set('51jk._initSid', '00-0')
  }
  store.commit('setSID', to.query.sid)
  if (!store.state.initializeSid) store.commit('setInitializeSid',  to.query.initializeSid || to.query.sid)
  if (to.query.sid === '00-0') {
    store.dispatch('center/loadSysCenterList')
  } else if (from.query.sid !== to.query.sid) {
    store.commit('center/setSysCenter', {id: to.query.sid})
    store.dispatch('center/loadSysCenterDetail', to.query.sid)
  }
  if (IsWechat()) {
    if (to.query.openid) {
      Cookies.set('51jk.qOpenId', to.query.openid)
    }
    InitWxConfig(store.state.sid)
  }
  next()
})
export default $router
